import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";

const axiosInstance = getAxiosInstance();

export const muteUserAPI = (targetUserId, duration, reason) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();

        const requestData = {
            target_user_id: targetUserId,
            duration: duration
        };


        axiosInstance
            .post(
                "/api/users/mute",
                requestData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                        [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                            `Bearer ${tokens.firebase_token}`,
                        "ngrok-skip-browser-warning": "true",
                    },
                }
            )
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                console.error("API Error:", err?.data || err);
                reject(err?.data || err);
            });
    });
};

export const unmuteUserAPI = (muteId) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .delete(`/api/users/unmute/${muteId}`, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.data || err));
    });
};

export const getMuteStatusAPI = (targetUserId) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get(`/api/users/mute-status`, {
                params: {
                    target_user_id: targetUserId
                },
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                console.error("Error fetching mute status:", err?.data || err);
                reject(err?.data || err);
            });
    });
};

